export function splitLastWord(text = '') {
    const spaceIdx = text.lastIndexOf(' ');
    if (spaceIdx === -1) return {before: '', lastWord: text};
    return {before: text.slice(0, spaceIdx) + ' ', lastWord: text.slice(spaceIdx + 1)};
}
